const state = () => ({
    currentLocale: ''
});

const mutations = {
    setCurrentLocale(state, data) {
        state.currentLocale = data
    }    
}

const getters = {
    currentLocale: (state) => state.currentLocale
}

const actions = {
    async setCurrentLocale(context, data) {   
        context.commit('setCurrentLocale', data)
    }
}

export default {
    state, mutations, actions, getters
}